module.exports = __webpack_public_path__ + "static/media/docx.77dc291e.png";